import { Box, useColorModeValue } from '@chakra-ui/react';
import Actions from './Action';
import Data from './Data';
import Profile from './Profile';

function Sidebar({ userData, isEditable }) {  // Accept isEditable as a prop
  const bgColor = useColorModeValue('white', 'black');
  const textColor = useColorModeValue('black', 'white');
  const headingColor = useColorModeValue('black', 'white');
  const borderColor = useColorModeValue('gray.200', 'white')
  
  return (
    <Box
      as="aside"
      flex={1}
      mr={{ base: 0, md: 5 }}
      mb={{ base: 5, md: 0 }}
      bg={bgColor}
      rounded="md"
      borderWidth={1}
      //borderColor={borderColor}
      style={{ transform: 'translateY(-100px)' }}
    >
      <Profile userData={userData} isEditable={isEditable} />  {/* Pass isEditable to Profile */}
      <Data userData={userData} />
      <Actions userData={userData} isEditable={isEditable}/>
    </Box>
  );
}

export default Sidebar;
